import { render, staticRenderFns } from "./ResultIrc.vue?vue&type=template&id=e97f89a4&"
import script from "./ResultIrc.vue?vue&type=script&lang=js&"
export * from "./ResultIrc.vue?vue&type=script&lang=js&"
import style0 from "./ResultIrc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports